import { render, staticRenderFns } from "./bestGoodsList.vue?vue&type=template&id=740fd070&scoped=true"
import script from "./bestGoodsList.vue?vue&type=script&lang=js"
export * from "./bestGoodsList.vue?vue&type=script&lang=js"
import style0 from "./bestGoodsList.vue?vue&type=style&index=0&id=740fd070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740fd070",
  null
  
)

export default component.exports